import { useEffect, useState } from 'react';
import * as S from './ScrollUpButtonStyles';

export interface ScrollUpButtonProps {
  threshold?: number;
  dataCy?: string;
  isRecommends?: boolean;
}

const ScrollUpButton = ({ threshold = 100, dataCy = '', isRecommends = false }: ScrollUpButtonProps) => {
  const [isDisplayed, setIsDisplayed] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  useEffect(() => {
    const toggleButtonVisibility = () => {
      setIsDisplayed(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', toggleButtonVisibility);
    return () => {
      window.removeEventListener('scroll', toggleButtonVisibility);
    };
  }, [threshold]);

  return isDisplayed ? (
    <S.ScrollUpButton
      data-cy={dataCy}
      onClick={scrollToTop}
      $isRecommends={isRecommends}
    />
  ) : null;
};

export default ScrollUpButton;
